import axios from 'api';
import { getCurrentApiUrl } from 'app/helpers';

require('dotenv').config();

export const GET_DASHBOARD_PRESS = '[CONSOLE] GET PRESS';
export const RESET_DASHBOARD_PRESS = '[CONSOLE] RESET_DASHBOARD_PRESS';

export function resetDashboardPress() {
  return {
    type: RESET_DASHBOARD_PRESS
  };
}

export function getDashboardPress() {
  const request = axios.get(`${getCurrentApiUrl()}/dashboard/press`, {});
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DASHBOARD_PRESS,
          payload: response.data
        });
      })
      .catch(err => err);
}
